module.exports = __webpack_public_path__ + "static/media/food-chains-in-peril_tablet.8a0c183e.jpg";